import { X, Home } from 'lucide-react';
import type { Room } from '../types';

interface EmptyRoomsModalProps {
  isOpen: boolean;
  onClose: () => void;
  emptyRooms: Room[];
  onRoomClick?: (roomNumber: string) => void;
}

export function EmptyRoomsModal({ isOpen, onClose, emptyRooms, onRoomClick }: EmptyRoomsModalProps) {
  if (!isOpen) return null;

  const handleRoomClick = (roomNumber: string) => {
    if (onRoomClick) {
      onRoomClick(roomNumber);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="card w-full max-w-lg max-h-[80vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b-2 border-light-border dark:border-dark-border">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary-600">
              <Home className="h-6 w-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-light-text dark:text-dark-text">
                Daftar Kamar Kosong
              </h2>
              <p className="text-sm text-light-textSecondary dark:text-dark-textSecondary">
                Total: {emptyRooms.length} kamar
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-light-surfaceAlt dark:hover:bg-dark-surfaceAlt transition-colors"
          >
            <X className="h-6 w-6 text-light-textSecondary dark:text-dark-textSecondary" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5 overflow-y-auto">
          {emptyRooms.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-lg text-light-textSecondary dark:text-dark-textSecondary">
                Tidak ada kamar kosong
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
              {emptyRooms.map((room) => (
                <button
                  key={room.number}
                  onClick={() => handleRoomClick(room.number)}
                  className="p-4 rounded-xl bg-primary-50 dark:bg-primary-900/30 border-2 border-primary-200 dark:border-primary-700 hover:bg-primary-100 dark:hover:bg-primary-800/50 hover:border-primary-400 dark:hover:border-primary-500 transition-all"
                >
                  <p className="text-lg font-bold text-primary-700 dark:text-primary-400">
                    {room.number}
                  </p>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-5 border-t-2 border-light-border dark:border-dark-border">
          <button
            onClick={onClose}
            className="btn-secondary w-full"
          >
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
}
